import { render, staticRenderFns } from "./LottieHappyEarth.vue?vue&type=template&id=08e6dfa1&scoped=true&"
import script from "./LottieHappyEarth.vue?vue&type=script&lang=js&"
export * from "./LottieHappyEarth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e6dfa1",
  null
  
)

export default component.exports